import ProgressBar from '@ui/ProgressBar';
import Typography from '@ui/Typography';
import Button from '@ui/Button';
import { cx } from 'cva';
import React from 'react';
import useStore from '@/stores/store';
import PostType from '@/constants/postType.constants';
import useHasUserSession from '@/hooks/useHasUserSession';
import useJoinNonProfitDialogStore from '../store/joinNonProfitDialogSlice';
import useConnectModalStore from '../store/connectModalSlice';
import OrgType from '@/constants/orgType.constant';
import { useRouter } from 'next/navigation';
import useNonProfitSignUpPopUpStore from '../store/nonProfitSignUpPopUpSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';

function VolunteeringProgress(props) {
  const { post, className } = props;
  const volunteerOpportunity = post.sourcePostData.volunteerOpportunity;
  const { volunteersReq } = volunteerOpportunity;
  const activeVolunteers = post.sourcePostData.totalVolunteers || 0;

  const hasUserSession = useHasUserSession();
  const router = useRouter();

  const showPostContributorDialog = useStore(
    (state) => state.postContributorDialog.showDialog,
  );
  const setShowJoinNonProfitModal = useJoinNonProfitDialogStore(
    (state) => state.setOpen,
  );
  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);

  const setShowNonProfitSignUpPopUp = useNonProfitSignUpPopUpStore(
    (state) => state.setOpen,
  );
  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  const handleShowAllContributors = () => {
    if (hasUserSession) {
      showPostContributorDialog(post, PostType.Volunteering, 'contributors');
    } else {
      if (
        [OrgType.Business, OrgType.ChangeMakers].includes(
          post.renderProps.company.orgType,
        )
      ) {
        // setShowConnectModal(true, post.renderProps.company);
        setShowCompanyConnectPopUp(true, post.renderProps.company);
      } else {
        // setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      }
    }
  };

  let infoText = `${volunteersReq} volunteer${
    volunteersReq > 1 ? 's' : ''
  } required`;
  if (activeVolunteers > 0) {
    infoText = `${activeVolunteers} volunteer${
      activeVolunteers > 1 ? 's' : ''
    } confirmed`;

    if (activeVolunteers < volunteersReq) {
      infoText += `, ${volunteersReq - activeVolunteers} more needed`;
    }
  }

  return (
    <div
      className={cx(
        'flex items-center gap-4 rounded-lg bg-body-background px-4 py-2',
        className,
      )}>
      <div className="flex w-full flex-col items-stretch justify-start gap-2">
        <div className="flex flex-1 items-center justify-start gap-2">
          <div className="flex items-end">
            <Typography variant="h3" className="whitespace-nowrap">
              {activeVolunteers}
            </Typography>
            <Typography variant="body2" className="whitespace-nowrap">
              /{volunteersReq}
            </Typography>
          </div>
          <Typography
            // variant="body1"
            // variant="caption"
            variant="hyperlink"
            // color="textSecondary"
            // className="hover:text-text-hyperlink"
            className="hover:cursor-pointer"
            onClick={handleShowAllContributors}>
            ({infoText})
          </Typography>
        </div>
        <div className="flex-1">
          <ProgressBar
            value={activeVolunteers}
            max={volunteersReq}
            background="white"
          />
        </div>
      </div>
    </div>
  );
}

export default VolunteeringProgress;
